import { api } from '../../services/authService';

/** Platform-admin user management calls shared by the listing and detail pages. */
export const adminUsersApi = {
  list: () => api.get('/api/v2/users/').then((r) => r.data),
  organizations: () => api.get('/api/v2/admin/organizations').then((r) => r.data),
  userOrganizations: (userId) => api.get(`/api/v2/users/${userId}/organizations`).then((r) => r.data),
  create: (payload) => api.post('/api/v2/admin/users', payload).then((r) => r.data),
  updateProfile: (userId, payload) => api.put(`/api/v2/admin/users/${userId}/profile`, payload).then((r) => r.data),
  setPassword: (userId, newPassword) =>
    api.put(`/api/v2/admin/users/${userId}/password`, { new_password: newPassword }).then((r) => r.data),
  sendPasswordReset: (userId) => api.post(`/api/v2/admin/users/${userId}/password-reset`).then((r) => r.data),
  setMemberships: (userId, memberships) =>
    api.put(`/api/v2/users/${userId}/organizations`, memberships).then((r) => r.data),
  setActive: (userId, isActive) => api.put(`/api/v2/users/${userId}/active?is_active=${isActive}`).then((r) => r.data),
  setAdmin: (userId, isAdmin) => api.put(`/api/v2/users/${userId}/admin?is_admin=${isAdmin}`).then((r) => r.data),
};

export function apiErrorText(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  return err?.message || fallback;
}

export function fullName(user) {
  return [user?.first_name, user?.last_name].filter(Boolean).join(' ');
}

export const compareUsersByName = (a, b) =>
  (a.first_name || '').localeCompare(b.first_name || '', undefined, { sensitivity: 'base' }) ||
  (a.last_name || '').localeCompare(b.last_name || '', undefined, { sensitivity: 'base' }) ||
  (a.email || '').localeCompare(b.email || '', undefined, { sensitivity: 'base' });

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const sanitizeName = (v) => v.replace(/[^a-zA-Z0-9-]/g, '').replace(/^\d+/, '');
export const sanitizeTitle = (v) => v.replace(/[^a-zA-Z0-9 ]/g, '').replace(/^\d+/, '');
export const sanitizeEmail = (v) => v.replace(/[^a-zA-Z0-9@_.+-]/g, '').replace(/^@+/, '').replace(/^\d+/, '');
